module.exports = __webpack_public_path__ + "static/media/send-alignments-explanation.61b1bce1.svg";